// extracted by mini-css-extract-plugin
export var logoContainer = "tamogatok-module--logo-container--jo4Pi";
export var wrapper = "tamogatok-module--wrapper--DqP9h";